<div class="flex flex-col items-center w-full h-full">
  <i class="fas fa-spinner fa-spin text-4xl text-blue-500"></i>
  <p class="mt-4 text-lg font-semibold text-gray-600">
    {{ 'logging_out' | translate | upperfirst }}
  </p>
</div>
